import { BackButton } from '@/src/modules/build-a-card/StyledComponents'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const StepBasedBackButton = ({
    currentStep,
    setCurrentStep,
    hideBackButton,
    skipPackaging = false,
}: {
    currentStep: number
    setCurrentStep: Function
    hideBackButton: boolean
    skipPackaging?: boolean
}) => {
    const previousStepNumber: number = skipPackaging ? 1 : currentStep - 1
    
    return (
        <>
            {!hideBackButton && (
                <BackButton
                    data-testid={'backButton'}
                    onClick={() => setCurrentStep(previousStepNumber)}
                >
                    <FontAwesomeIcon
                        icon={faArrowLeft}
                        style={{ marginRight: '0.5rem' }}
                    />
                    &nbsp;Back
                </BackButton>
            )}
        </>
    )
}

export default StepBasedBackButton
